import { HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { SupabaseService } from 'src/app/services/supabase.service';
import { ToasterService } from 'src/app/services/toaster.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'travel-ui-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ResetPasswordComponent>, private formBuilder: UntypedFormBuilder, public toasterService: ToasterService, private supabaseServie: SupabaseService) { 

  }

  @Input()
  resetForm!: UntypedFormGroup;
  Showloader: boolean = false;
  // isHuman: boolean = false;
  // recaptchaKey: string = environment.RecaptchaKeyRoamto;
  

  async onResetSubmit(){
    this.Showloader = true;
    if(!this.resetForm.valid){
      this.toasterService.error("Please enter a valid email address");
      this.Showloader = false;
      return;
    }
    // if(!this.isHuman){
    //   this.toasterService.error("Please verify that you are a Human");
    //   this.Showloader = false;
    //   return;
    // }
    this.supabaseServie.getPasswordResetLink(this.resetForm.value.email).subscribe((res: HttpResponse<any>)=>{
      if(res.ok){
        this.Showloader = false;
        this.toasterService.success("Password reset link has been sent to you email", 3000);
        setTimeout(()=>{this.dialogRef.close()}, 3000);
      }
    }, (error)=>{
      this.Showloader = false;
      this.toasterService.error("Something went wrong, please try again");
    })

    
  }

  // onRecaptchaResolved(event: any){
  //   this.isHuman = false;
  //   if(event){
  //     this.isHuman = true;
  //   }
  // }

  // onCaptchaReset(){
  //   this.isHuman = false;
  // }

  loadRecaptchaScript(){
    try{
      const reCaptcha = document.createElement("reCaptcha") as any;
      reCaptcha.src = 'https://www.google.com/recaptcha/api.js';
      reCaptcha.async = true;
      reCaptcha.defer = true;
      document.head.appendChild(reCaptcha);
      console.log("loaded");
  }
    catch(ex){
      console.error(ex);
    }
    
  }

  ngOnInit(): void {
    // this.loadRecaptchaScript();

    this.resetForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

}
